module.exports = __webpack_public_path__ + "img/pwn.6c821a5d.svg";